import { useState } from "react";
import { formatTime } from "../../components/Util/format_date";

import live_icon from './../Channels/images/live_icon.png'
import timeshift_icon from './../Channels/images/timeshift_icon_active.png'

export default ({
    btn_full_screen,
    currentTime,
    duration,
    btn_previous_channel,
    btn_next_channel,
    btn_play_pause,
    show_time_shift,
    playPause,
    change_handle_range,
    valueProgress,
    showArchive,
    active_channel,
    btn_back_forward,
    btn_forward,
    show_live_btn
}) => {

    return (
        <div className="parent_controls_live">
            <div className="top_field_controls">
                <div className="icon_channel">
                    <img src={active_channel.image} alt="" />
                </div>
                <div className="name_channel">
                    {active_channel.title || active_channel.name}
                </div>
            </div>
            {/* <div className="middel_field_controls" onDoubleClick={e => e.stopPropagation()}>
                <div className="btns_mid_controls btn_prev_player">
                    <div className={'icon_control_player'}></div>
                </div>
                <div className="btns_mid_controls btn_back_forward" onClick={show_time_shift}>
                    <div className={'icon_control_player'}></div>
                </div>
                <div className="btns_mid_controls btn_play" onClick={btn_play_pause}>
                    <div
                        className={`${playPause ? 'icon_control_player_play' : 'icon_control_player_pause'} icon_control_player`}></div>
                </div>
                <div className="btns_mid_controls btn_forward">
                    <div className={'icon_control_player'}></div>
                </div>
                <div className="btns_mid_controls btn_next_player">
                    <div className={'icon_control_player'}></div>
                </div>
            </div> */}
            <div className="bottom_field_controles" onDoubleClick={e => e.stopPropagation()}>

                <div className="progress_field">


                    <div className={"progress_player " + (showArchive == 'live' ? 'disable_inp' : '')}>
                        <input
                            type="range"
                            value={showArchive == 'live' ? 100 : valueProgress}
                            onChange={change_handle_range}
                            style={{ background: `linear-gradient(to right, white 0%, white ${showArchive == 'live' ? 100 : valueProgress}%, #5E5E5E ${showArchive == 'live' ? 100 : valueProgress}%, #5E5E5E 100%)` }}
                        />
                    </div>
                    {
                        showArchive != 'live' ?
                            <div className="currenttime_player_live" style={{ textAlign: 'left' }}>
                                {showArchive == 'archive' ? '' + formatTime(currentTime) : '-' + formatTime(duration - currentTime)}
                            </div>
                            : null
                    }


                    {showArchive == 'live' ?
                        <div className="icon_live">
                            <img src={live_icon} alt="" />
                        </div> :
                        showArchive == 'timeshift' ?
                            <div className="icon_live">
                                <img src={timeshift_icon} alt="" />
                            </div> :
                            <div className="duration_player_live">{formatTime(duration)}</div>
                    }


                </div>
                <div className="parent_btns_group_player">
                    {
                        showArchive == 'live' ?
                            <div className="go_timeshift_btn parent_shadow" onClick={show_time_shift}>
                                <div className="shadow"></div>
                                <div className="icon_timeshift"></div>
                            </div>
                            :
                            <div className="btn_go_to_live" onClick={show_live_btn}>
                                Turn to live
                            </div>
                    }

                    <div className="btns_group_player">
                        <div className="btn_item_player parent_shadow" onClick={btn_previous_channel} onDoubleClick={e => e.stopPropagation()}>
                            <div className="shadow"></div>
                            <div className="icon_item_player prev"></div>
                        </div>
                        <div className={"btn_item_player parent_shadow " + (showArchive == 'live' ? 'disable' : '')} onClick={btn_back_forward} onDoubleClick={e => e.stopPropagation()}>
                            <div className="shadow"></div>
                            <div className="icon_item_player backward"></div>
                        </div>
                        <div className="btn_item_player parent_shadow" onClick={btn_play_pause} onDoubleClick={e => e.stopPropagation()}>
                            <div className="shadow"></div>
                            <div className={`${playPause ? 'play' : 'pause'} icon_item_player `}></div>
                        </div>
                        <div className={"btn_item_player parent_shadow " + (showArchive == 'live' ? 'disable' : '')} onClick={btn_forward} onDoubleClick={e => e.stopPropagation()}>
                            <div className="shadow"></div>
                            <div className="icon_item_player forward"></div>
                        </div>
                        <div className="btn_item_player parent_shadow" onClick={btn_next_channel} onDoubleClick={e => e.stopPropagation()}>
                            <div className="shadow"></div>
                            <div className="icon_item_player next"></div>
                        </div>
                    </div>

                    <div className="full_screen_btn parent_shadow" onClick={btn_full_screen} onDoubleClick={e => e.stopPropagation()}>
                        <div className="shadow"></div>
                        {/* <img src={fullScreen ? icon_small_screen : icon_full_screen} alt="" /> */}
                    </div>

                </div>

            </div>
        </div>
    )
}